import React, { useState } from "react";
import { FaQrcode } from "react-icons/fa";
// `qrcode.react` v3+ exports named components, not a default. Match
// the rest of the codebase (`src/helper/qrcodeModal.js`) — the named
// `QRCodeCanvas` is the same renderer we'd get from the default
// import on v2, just explicit about the canvas-vs-svg choice.
import { QRCodeCanvas as QRCode } from "qrcode.react";

/**
 * Collapsible "Open on mobile" QR code.
 *
 * The QR encodes the current page URL (whatever /pay/* shape the
 * user navigated to — short code, slug, or UUID). Scanning it with
 * a phone opens the same payment page on the phone's browser where
 * the user can connect a mobile wallet (MetaMask Mobile / Rainbow
 * / Trust). Desktop → mobile hand-off is the common payment UX.
 *
 * Uses `qrcode.react` which is already an app dependency
 * (package.json carries ^3.1.0) so no new install. Renders at 160px
 * — big enough to scan comfortably in a phone camera, small enough
 * to not dominate the payment panel.
 */
export function QRCodeToggle() {
  const [open, setOpen] = useState(false);
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";

  return (
    <>
      <button
        type="button"
        className="pay-qr-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
          <FaQrcode size={14} /> Open on mobile
        </span>
        <span aria-hidden="true">{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div className="pay-qr-panel">
          <QRCode value={currentUrl} size={160} level="M" includeMargin />
          <div>
            Scan with your phone's camera to continue on mobile. The URL is
            public — no session hand-off, just the payment link.
          </div>
        </div>
      )}
    </>
  );
}
